<template>
  <BaseCard
    ref="card"
  >
    <template #body>
      <div class="container">
        <div>
          <h3>
            {{ title }}
          </h3>
          <span>{{ modelType }}</span>
        </div>
        <SVGIcon
          :iconName="'download'"
          :width="'36px'"
          :height="'36px'"
        />
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import { ref } from 'vue';
import BaseCard from '@/components/BaseCard.vue';
import SVGIcon from '@/components/SVGIcon.vue';

const props = defineProps({
  title: { type: String, default: '' },
  modelType: { type: String, default: '' },
});

</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
